import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import Switch from '@material-ui/core/Switch';
import Countdown from 'components/Countdown';
import {
  NARRATIVE, MEETING, SPEED_DATING, EMBED,
} from 'constants/types';
import callIcon from 'assets/images/calls/callIcon.svg';
import { getURLByPhase } from 'utils/calls';
import { CallForImpactWrapper, HeaderCard } from './styles';

class Call4ImpactCard extends Component {
  constructor(props) {
    super(props);

    const { itemsPreferencesFromSerendipity, data: { id }, data } = this.props;

    const status = !_.find(itemsPreferencesFromSerendipity, item => item.element_type === NARRATIVE && item.element_id === id && !item.enabled);

    this.state = {
      enabled: status,
      start: data.progress === 0,
      reStart: data.progress > 0,
      hall: true,
      newCall: data.progress === 0,
    };
  }

  handleClick = (event) => {
    const { data, history, onClickStart } = this.props;
    if (onClickStart) {
      onClickStart(data);
    } else {
      history.push(getURLByPhase(data));
    }
    event.stopPropagation();
  }

  handleHallClick = (event) => {
    const { data: { id }, history } = this.props;
    history.push(`/calls/${id}/hall`);
    event.stopPropagation();
  }

  handleClickCall = () => {
    const { data: { id }, history } = this.props;
    history.push(`/calls/${id}`);
  }

  handleClickPlan = (event) => {
    const { planId, history, type } = this.props;

    if (type === MEETING) {
      history.push(`/zoom-meeting/${planId}`);
    }

    if (type === SPEED_DATING) {
      history.push(`/speed-dating/${planId}`);
    }

    event.stopPropagation();
  }

  handleChangeEnabled = (event) => {
    const { enableItemFromSerendipity, disableItemFromSerendipity, data: { id } } = this.props;
    this.setState({ enabled: event.target.checked });
    if (event.target.checked) {
      enableItemFromSerendipity(NARRATIVE, id);
    } else {
      disableItemFromSerendipity(NARRATIVE, id);
    }
  }

  render() {
    const {
      data, literals, planId, type,
    } = this.props;

    const {
      start, newCall, hall, enabled, reStart,
    } = this.state;
    const { background_image: image, name, description } = data;
    let minDateEvent = null;
    const today = moment().format('YYYY-MM-DD');

    data.meetings.forEach((meeting) => {
      const meetingDay = moment(meeting.start_date, 'X').format('YYYY-MM-DD');
      if (meetingDay >= today && (!minDateEvent || meeting.start_date < minDateEvent)) {
        minDateEvent = meeting.start_date;
      }
    });

    data.speed_datings.forEach((meeting) => {
      const meetingDay = moment(meeting.start_date, 'X').format('YYYY-MM-DD');
      if (meetingDay >= today && (!minDateEvent || meeting.start_date < minDateEvent)) {
        minDateEvent = meeting.start_date;
      }
    });

    return (
      <CallForImpactWrapper className='c4impact_card' onClick={this.handleClickCall}>
        <HeaderCard img={`url(${image})`}>
          <div className='opacity' />
          <div className='content'>
            <img src={callIcon} alt='' style={{ height: '1.5rem' }} />
            <div className='name'>{name}</div>
          </div>
          {reStart && (
            <Switch
              className='switch'
              checked={enabled}
              onChange={this.handleChangeEnabled}
              size='small'
              name='check_enabled'
              color='primary'
            />
          )}
        </HeaderCard>
        <div className='footer'>
          <div className='content_detail'>
            {minDateEvent ? (
              <React.Fragment>
                <div className='date'>{`${literals.liveEvent}: ${moment(minDateEvent, 'X').format('DD/MM/YYYY')}`}</div>
                <Countdown time={minDateEvent} enabled={enabled} />
              </React.Fragment>
            ) : null}
          </div>
          <div className='desc_call'>
            {description}
          </div>
          <div className='footer_bottom'>
            {type === SPEED_DATING && (
              <div className='plan_speed_dating'>
                <button type='button' onClick={this.handleClickPlan}>
                  {literals.planSpeedDating}
                </button>
              </div>
            )}
            {type === MEETING && (
              <div className='plan_meeting'>
                <button type='button' onClick={this.handleClickPlan}>
                  {literals.planMeeting}
                </button>
              </div>
            )}
            <div className='form_buttons' style={{ marginTop: planId !== 0 ? '' : '4.5rem' }}>
              {start && enabled && <button className='primary btn-sm claim' onClick={this.handleClick}>{literals.start}</button>}
              {reStart && enabled && <button className='primary btn-sm claim white' onClick={this.handleClick}>{literals.reStart}</button>}
              {hall && type !== EMBED && start && !reStart && enabled && <button className='primary btn-sm claim white' onClick={this.handleHallClick}>{literals.hall}</button>}
              {hall && type !== EMBED && !start && reStart && enabled && <button className='primary btn-sm claim' onClick={this.handleHallClick}>{literals.hall}</button>}
              {!enabled && <button className='primary btn-sm claim black'>{literals.start}</button>}
            </div>
          </div>
          <div className='options'>
            {newCall && enabled && <div className='status'>New</div>}
            {newCall && !enabled && <div className='status disabled'>New</div>}
          </div>
        </div>
      </CallForImpactWrapper>
    );
  }
}

Call4ImpactCard.propTypes = {
  literals: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  type: PropTypes.string,
  onClickStart: PropTypes.func,
};

Call4ImpactCard.defaultProps = {
  type: '',
  onClickStart: null,
};

export default Call4ImpactCard;



// WEBPACK FOOTER //
// ./src/components/Cards/Call4ImpactCard/components/index.jsx